import React from 'react';
import Wrap from './Wrap';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const WelcomeSection = () => {
  return (
    <Wrap noPadding paddingTop={8} paddingBottom={8}>
      <Typography variant="h2" align="center" color="secondary" gutterBottom>
        Willkommen beim DEPV.
      </Typography>
      <Box maxWidth={650} margin="auto">
        <Typography variant="h6" align="center">
          Wir sind die Interessenvertretung für Unternehmen rund um das Heizen
          mit Holzpellets und moderne Holzenergie.
        </Typography>
      </Box>
    </Wrap>
  );
};

export default WelcomeSection;
